Vue.component('mypostnl', {
    data() {
        return {
            uuid: "",

            zipCodeSearchTerm: '',
            zipCodeIsSearchOpen: false,
            zipCodeSearchResults: [],
            zipCodeTimer: null,

            citySearchTerm: '',
            cityIsSearchOpen: false,
            citySearchResults: [],
            cityTimer: null,
            cityReadOnly: true,
            cityDisabled: true,

            fullAddressSearchTerm: '',
            fullAddressIsSearchOpen: false,
            fullAddressSearchResults: [],
            fullAddressTimer: null,
            fullAddressReadOnly: true,
            fullAddressDisabled: true,

            houseNumberSearchTerm: '',
            houseNumberIsSearchOpen: false,
            houseNumberSearchResults: [],
            houseNumberTimer: null,

            houseNumberAdditionSearchTerm: '',
            houseNumberAdditionIsSearchOpen: false,
            houseNumberAdditionSearchResults: [],
            houseNumberAdditionTimer: null,
            houseNumberAdditionReadOnly: true,
            houseNumberAdditionDisabled: true,

            validateRunning: false,

            address: {},

            mapId: 'shop-map',
            map: null,
            marker: null,

            automatic: true,
            init: false

        };
    },
    props: ['defaultpostalcode', 'defaulthousenumber', 'defaulthousenumberaddition', 'defaultcity', 'defaultfulladdress',
        'postalcodeid', 'housenumberid', 'housenumberadditionid', 'streetid', 'cityid', 'fulladdressid', 'marketcountry', 'zipcodelength',
        'latitudeid', 'longitudeid'],
    mounted() {
        this.uuid = this.generateUUID();

        console.log(`postnl init ${this.uuid}`);

        if (this.fulladdressid != null && this.fulladdressid.length > 0) {

            this.zipCodeSearchTerm = this.RemoveSpaces(this.defaultpostalcode);
            this.houseNumberSearchTerm = this.defaulthousenumber;
            this.houseNumberAdditionSearchTerm = this.defaulthousenumberaddition;
            this.citySearchTerm = this.defaultcity;
            this.fullAddressSearchTerm = this.defaultfulladdress;

        } else {

            this.zipCodeSearchTerm = this.RemoveSpaces(this.defaultpostalcode);
            this.houseNumberSearchTerm = this.defaulthousenumber;
            this.houseNumberAdditionSearchTerm = this.defaulthousenumberaddition;
        }

        if (this.zipCodeSearchTerm.length !== Number(this.zipcodelength)) {
            this.zipCodeResetSearchTerm();

            this.houseNumberResetSearchTerm();

            this.houseNumberAdditionResetSearchTerm();

            this.cityResetSearchTerm();

            this.fullAddressResetSearchTerm();

        }

        this.initvalidate();

        if (this.fulladdressid != null && this.fulladdressid.length > 0) {

            if (this.zipCodeSearchTerm.length === Number(this.zipcodelength) &&
                this.citySearchTerm.length >= 2 &&
                this.fullAddressSearchTerm.length >= 5
            ) {
                this.validate(0);
            }
        }  
        else {

            if (this.zipCodeSearchTerm.length === Number(this.zipcodelength) &&
                String(this.houseNumberSearchTerm).length >= 1) {

                this.validate(0);
            }
        }

    },

    methods: {

        initvalidate() {

            if (this.fulladdressid != null && this.fulladdressid.length > 0) {

                if (this.zipCodeSearchTerm.length === Number(this.zipcodelength) &&
                    this.citySearchTerm.length >= 2 &&
                    this.fullAddressSearchTerm.length >= 5
                ) {

                    this.houseNumberAdditionReadOnly = false;
                    this.houseNumberAdditionDisabled = false;
                }
                else {
                    this.houseNumberAdditionReadOnly = true;
                    this.houseNumberAdditionDisabled = true;
                }

                if (this.zipCodeSearchTerm.length === Number(this.zipcodelength) &&
                    this.citySearchTerm.length >= 2
                ) {

                    this.fullAddressReadOnly = false;
                    this.fullAddressDisabled = false;
                }
                else {
                    this.fullAddressReadOnly = true;
                    this.fullAddressDisabled = true;
                }

                if (this.zipCodeSearchTerm.length === Number(this.zipcodelength)) {

                    this.cityReadOnly = false;
                    this.cityDisabled = false;
                }
                else {
                    this.cityReadOnly = true;
                    this.cityDisabled = true;
                }
            }
            else {

                if (this.zipCodeSearchTerm.length === Number(this.zipcodelength) &&
                    String(this.houseNumberSearchTerm).length >= 1) {

                    this.houseNumberAdditionReadOnly = false;
                    this.houseNumberAdditionDisabled = false;
                }
                else {
                    this.houseNumberAdditionReadOnly = true;
                    this.houseNumberAdditionDisabled = true;
                }
            }


        },

        createMap(latLng) {
            const mapElement = document.getElementById(this.mapId);
            const options = {
                zoom: 18,
                minZoom: 7,
                maxZoom: 19,
                mapTypeControl: false,
                //fullscreenControl: false,
                streetViewControl: false,
                zoomControl: false,
                center: latLng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapId: this.mapId
            };

            this.map = new google.maps.Map(mapElement, options);
        },
        createMarker(latLng) {

            this.marker = new google.maps.Marker({
                map: this.map,
                position: latLng
            });
        },

        generateUUID: () => {
            const url = URL.createObjectURL(new Blob())
            const [id] = url.toString().split('/').reverse()
            URL.revokeObjectURL(url)
            return id
        },

        sortShoplistByZipcode(e) {

            this.$emit('sortshoplist', e);
        },


        //----------------------------------------

        RemoveSpaces(val) {
            if (val) {
                return val.replace(/\s/g, '')
            }

            return val;
        },

        zipCodeResetSearchTerm() {

            this.zipCodeSearchTerm = '';

        },

        zipCodeFocus(e) {

            return;

        },

        zipCodeBlur(e) {

            return;

        },

        zipCodeInputChanged(event) {

            if (!this.automatic) {
                return;
            }

            this.houseNumberResetSearchTerm();

            this.houseNumberAdditionResetSearchTerm();

            this.cityResetSearchTerm();

            this.fullAddressResetSearchTerm();

            if (this.zipCodeSearchTerm && this.zipCodeSearchTerm.indexOf(' ') !== -1) {
                this.zipCodeSearchTerm = this.RemoveSpaces(this.zipCodeSearchTerm);
            }

            this.initvalidate();

            if (this.zipCodeSearchTerm.length === Number(this.zipcodelength)) {
                clearTimeout(this.zipCodeTimer);

                this.zipCodeTimer = setTimeout(() => {

                    this.init = false;
                    this.validate(0);
                }
                    , 1000);


            } else {
                clearTimeout(this.zipCodeTimer);
            }

        },
        zipCodeSelectResult(index) {

            return;

        },

        //----------------------------------------

        cityResetSearchTerm() {

            this.citySearchTerm = '';

        },

        cityFocus(e) {

            return;

        },

        cityBlur(e) {

            return;
        },

        cityInputChanged(event) {

            if (!this.automatic) {
                return;
            }

            //console.log('cityInputChanged');

            this.houseNumberResetSearchTerm();

            this.houseNumberAdditionResetSearchTerm();

            this.fullAddressResetSearchTerm();

            this.initvalidate();

            clearTimeout(this.cityTimer);

            this.cityTimer = setTimeout(() => {

                this.init = false;
                this.validate(0);
            }
                , 1000);



        },
        citySelectResult(index) {

            return;

        },
        //----------------------------------------

        fullAddressResetSearchTerm() {

            this.fullAddressSearchTerm = '';

        },

        fullAddressFocus(e) {

            return;

        },

        fullAddressBlur(e) {

            return;

        },

        fullAddressInputChanged(event) {

            if (!this.automatic) {
                return;
            }

            //console.log('fullAddressInputChanged');

            this.houseNumberResetSearchTerm();

            this.houseNumberAdditionResetSearchTerm();

            this.initvalidate();

            clearTimeout(this.fullAddressTimer);

            this.fullAddressTimer = setTimeout(() => {

                this.init = false;
                this.validate(0);
            }
                , 1000);

        },
        fullAddressSelectResult(index) {

            return;

        },

        //---------------------------------------------------

        houseNumberResetSearchTerm() {

            this.houseNumberSearchTerm = '';

        },

        houseNumberFocus(e) {

            return;

        },

        houseNumberBlur(e) {

            return;
        },

        houseNumberInputChanged(event) {

            if (!this.automatic) {
                return;
            }

            //console.log('houseNumberInputChanged');

            this.houseNumberAdditionResetSearchTerm();

            this.initvalidate();

            clearTimeout(this.houseNumberTimer);

            this.houseNumberTimer = setTimeout(() => {

                this.init = false;
                this.validate(0);
            }
                , 1000);


        },
        houseNumberSelectResult(index) {

            return;

        },
        //---------------------------------------------------

        houseNumberAdditionResetSearchTerm() {

            this.houseNumberAdditionSearchTerm = '';

        },

        houseNumberAdditionFocus(e) {

            return;

        },

        houseNumberAdditionBlur(e) {

            return;

        },

        houseNumberAdditionInputChanged() {

            if (!this.automatic) {
                return;
            }

            console.log('houseNumberAdditionInputChanged');

            clearTimeout(this.houseNumberAdditionTimer);

            this.houseNumberAdditionTimer = setTimeout(() => {

                this.init = false;
                this.validate(0);
            }
                , 1000);

        },
        houseNumberAdditionSelectResult(index) {

            return;

        },

        //-------------------------------------------

        validate(srcindex) {

            if (this.fulladdressid != null && this.fulladdressid.length > 0) {

                if (this.zipCodeSearchTerm.length === Number(this.zipcodelength) &&
                    this.citySearchTerm.length >= 2 &&
                    this.fullAddressSearchTerm.length >= 5
                ) {

                    this.validateRunning = true;
                    fetch(encodeURI(`/api/postnl/validate?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}&city=${this.citySearchTerm}&fulladdress=${this.fullAddressSearchTerm}`), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': document.documentElement.lang,
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        credentials: 'same-origin'
                    }).then(response => response.json()).then((autocompleteResponse) => {

                        if (this.validateRunning === true) {

                            this.address = autocompleteResponse;

                            if (this.address != null && this.address.address1 != null && this.address.address1.length > 1 && this.address.mailabilityScore === 100) {

                                if (document.activeElement !== document.getElementById(this.postalcodeid)) {
                                    this.zipCodeSearchTerm = this.address.postalCode;
                                }

                                document.getElementById(this.streetid).value = this.address.streetName;
                                document.getElementById(this.housenumberid).value = this.address.houseNumber;

                                if (this.marketcountry !== 'FR') {
                                    document.getElementById(this.housenumberadditionid).value = this.address.houseNumberAddition;
                                }

                                this.houseNumberAdditionReadOnly = false;
                                this.houseNumberAdditionDisabled = false;

                                this.fullAddressSearchTerm = this.address.address1;

                                /*
                                if (this.address.latitude != null && this.address.longitude != null) {
        
                                    var latLng = new google.maps.LatLng(this.address.latitude, this.address.longitude);
        
                                    if (!this.map) {
                                        this.createMap(latLng);
                                    } else {
        
                                        this.map.setZoom(18);
        
                                        this.map.setCenter(latLng);
                                    }
        
                                    if (!this.marker) {
                                        this.createMarker(latLng)
                                    } else {
                                        this.marker.setPosition(latLng);
                                    }
        
                                }*/
                                //});


                            } else {
                                document.getElementById(this.streetid).value = '';
                                document.getElementById(this.housenumberid).value = '';

                                if (this.marketcountry !== 'FR') {
                                    document.getElementById(this.housenumberadditionid).value = '';
                                }

                                //this.houseNumberAdditionSearchTerm = '';
                                this.houseNumberAdditionReadOnly = true;
                                this.houseNumberAdditionDisabled = true;

                                if (srcindex === 5) {
                                    document.getElementById(this.fulladdressid).focus();
                                }

                            }

                        }

                        this.init = true;

                        Vue.nextTick(() => {
                            this.validateRunning = false;
                        });
                    });
                }
                else {
                    this.address = {};
                    document.getElementById(this.streetid).value = '';
                    document.getElementById(this.housenumberid).value = '';
                    document.getElementById(this.housenumberadditionid).value = '';

                    //this.houseNumberAdditionSearchTerm = '';
                    this.houseNumberAdditionReadOnly = true;
                    this.houseNumberAdditionDisabled = true;

                }

            }
            else {

                if (this.zipCodeSearchTerm.length === Number(this.zipcodelength) &&
                    String(this.houseNumberSearchTerm).length >= 1) {

                    this.validateRunning = true;

                    //console.log(`/api/postnl/validate?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}&housenumber=${this.houseNumberSearchTerm}&addition=${this.houseNumberAdditionSearchTerm}`);

                    fetch(encodeURI(`/api/postnl/validate?uuid=${this.uuid}&zipcode=${this.zipCodeSearchTerm}&housenumber=${this.houseNumberSearchTerm}&addition=${this.houseNumberAdditionSearchTerm}`), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': document.documentElement.lang,
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        credentials: 'same-origin'
                    }).then(response => response.json()).then((autocompleteResponse) => {

                        if (this.validateRunning === true) {

                            this.address = autocompleteResponse;

                            //if (srcindex !== 11) {
                            //this.checkAnyHouseNumberAddition();
                            //}

                            if (this.address != null && this.address.address1 != null && this.address.address1.length > 1 && this.address.mailabilityScore === 100) {

                                if (document.activeElement !== document.getElementById(this.postalcodeid)) {
                                    this.zipCodeSearchTerm = this.address.postalCode;
                                }

                                if (document.activeElement !== document.getElementById(this.housenumberid)) {
                                    this.houseNumberSearchTerm = this.address.houseNumber;
                                }

                                if (document.activeElement !== document.getElementById(this.housenumberadditionid)) {
                                    this.houseNumberAdditionSearchTerm = this.address.houseNumberAddition;
                                }

                                document.getElementById(this.streetid).value = this.address.streetName;
                                document.getElementById(this.cityid).value = this.address.cityName;

                                if (this.latitudeid !== null && document.getElementById(this.latitudeid) !== null) {
                                    document.getElementById(this.latitudeid).value = this.address.latitude;
                                }
                                if (this.longitudeid !== null && document.getElementById(this.longitudeid) !== null) {
                                    document.getElementById(this.longitudeid).value = this.address.longitude;
                                }

                                /*
                                if (this.address.latitude != null && this.address.longitude != null) {
        
                                    var latLng = new google.maps.LatLng(this.address.latitude, this.address.longitude);
        
                                    if (!this.map) {
                                        this.createMap(latLng);
                                    } else {
        
                                        this.map.setZoom(18);
        
                                        this.map.setCenter(latLng);
                                    }
        
                                    if (!this.marker) {
                                        this.createMarker(latLng)
                                    } else {
                                        this.marker.setPosition(latLng);
                                    }
        
                                }*/
                                //});


                            } else {
                                document.getElementById(this.streetid).value = '';
                                document.getElementById(this.cityid).value = '';

                                if (this.latitudeid && document.getElementById(this.latitudeid)) {
                                    document.getElementById(this.latitudeid).value = '';
                                }
                                if (this.longitudeid && document.getElementById(this.longitudeid)) {
                                    document.getElementById(this.longitudeid).value = '';
                                }

                                //this.houseNumberAdditionReadOnly = true;
                                //this.houseNumberAdditionDisabled = true;
                            }

                        }

                        this.init = true;

                        Vue.nextTick(() => {
                            this.validateRunning = false;
                        });
                    });
                }
                else {
                    this.address = {};
                    document.getElementById(this.streetid).value = '';
                    document.getElementById(this.cityid).value = '';

                    if (this.latitudeid && document.getElementById(this.latitudeid)) {
                        document.getElementById(this.latitudeid).value = '';
                    }
                    if (this.longitudeid && document.getElementById(this.longitudeid)) {
                        document.getElementById(this.longitudeid).value = '';
                    }

                    this.houseNumberAdditionReadOnly = true;
                    this.houseNumberAdditionDisabled = true;

                }

            }
        },

    }
});
